document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("CompanyRegistrationForm");
  if (!form) return;
  const emailInput = form.querySelector('input[name="customer[email]"]');
  let prefilledEmail = "";

  try {
    prefilledEmail =
      window.sessionStorage.getItem("companyRegistrationEmail") || "";
    window.sessionStorage.removeItem("companyRegistrationEmail");
  } catch (error) {
    prefilledEmail = "";
  }

  if (prefilledEmail && emailInput && !emailInput.value) {
    emailInput.value = prefilledEmail;
  }

  const submitBtn = form.querySelector('button[type="submit"]');
  const submitSpinner = submitBtn?.querySelector(".loading__spinner");
  const statusEl = form.querySelector("[data-form-status]");
  const shippingCountrySelect = document.getElementById(
    "CompanyRegistration-country",
  );
  const shippingProvinceSelect = document.getElementById(
    "CompanyRegistration-province",
  );
  const billingCountrySelect = document.getElementById(
    "CompanyRegistration-billing-country",
  );
  const billingProvinceSelect = document.getElementById(
    "CompanyRegistration-billing-province",
  );
  const shippingCountryCodeInput = document.getElementById(
    "CompanyRegistration-country-code",
  );
  const billingCountryCodeInput = document.getElementById(
    "CompanyRegistration-billing-country-code",
  );
  const shippingZipInput = document.getElementById("CompanyRegistration-zip");
  const billingZipInput = document.getElementById(
    "CompanyRegistration-billing-zip",
  );

  const modal = document.getElementById("B2BSuccessModal");
  const modalMessage = modal?.querySelector("[data-modal-message]");

  // =========================
  // TRANSLATIONS
  // =========================
  const translations = {
    required: form.dataset.errorRequired || "This field is required",
    email: form.dataset.errorEmail || "Enter a valid email",
    province: form.dataset.province || "Province / State",
    provinceNoCountry: form.dataset.provinceNoCountry || "Choose country first",
    success:
      form.dataset.successMessage ||
      "Registration successful. We'll be in touch shortly.",
    error: form.dataset.errorLabel || "Error",
    fixErrors: form.dataset.fixErrors || "Please fix the highlighted fields.",
    genericError:
      form.dataset.genericError || "Something went wrong. Please try again.",
    phone:
      form.dataset.errorPhone ||
      "Enter a valid phone number (digits and common phone symbols only).",
    address:
      form.dataset.errorAddress ||
      "Enter a valid address (at least 3 characters, letters/numbers).",
    countryCode:
      form.dataset.errorCountryCode ||
      "Enter a valid country code (2-3 letters).",
    zip: form.dataset.errorZip || "Enter a valid postal code.",
    selectCountry: form.dataset.errorSelectCountry || "Select a country",
    selectProvince:
      form.dataset.errorSelectProvince || "Select a province or state",
  };

  const phonePattern = /^[0-9+\-().\s]+$/;
  const addressPattern = /^[\p{L}\p{N}\s,.'#\-\/]+$/u;
  const countryCodePattern = /^[A-Za-z]{2,3}$/;

  // Only the countries the form offers, so an unknown code skips the check
  // rather than rejecting a postal code it cannot judge. Each message names a
  // full example: the common mistake is typing the three-character regional
  // prefix - "R2A" - which is half a Canadian postal code, not a short one.
  const zipRules = {
    CA: {
      pattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
      example: "K1A 0B1",
      message:
        form.dataset.errorZipCa ||
        "Enter a full six-character postal code, for example K1A 0B1.",
    },
    US: {
      pattern: /^\d{5}(-\d{4})?$/,
      example: "90210",
      message:
        form.dataset.errorZipUs ||
        "Enter a five-digit ZIP code, for example 90210.",
    },
  };

  // Until a country is picked there is no strict rule to apply, and without
  // this the field would call anything typed into it valid - and the theme
  // paints a valid field green, which reads as approval. Every postal code the
  // form can accept carries a digit, so that is the floor.
  const zipShapePattern = /^(?=.*\d)[A-Za-z\d][A-Za-z\d -]{1,9}$/;

  // =========================
  // FIELD MAPPING
  // =========================
  // Errors come back as a path into the API's own input, not as a field name:
  // ["input", "companyLocation", "shippingAddress", "zip"]. The scope segment
  // says which address it concerns, the leaf says which field, and the leaves
  // are `CompanyAddressInput`'s names rather than the form's.
  const addressFieldMap = {
    address1: "address",
    address2: "address2",
    city: "city",
    zoneCode: "province",
    zip: "zip",
    // The country code is a hidden input with nowhere to show a message, so
    // the dropdown it is derived from carries it instead.
    countryCode: "country",
  };

  const contactFieldMap = {
    email: "customer[email]",
    firstName: "customer[first_name]",
    lastName: "customer[last_name]",
    phone: "phone",
    companyName: "company_name",
  };

  function resolveBackendField(path) {
    if (!Array.isArray(path)) return null;

    const leaf = path[path.length - 1];

    const scope = path.includes("billingAddress")
      ? "billing"
      : path.includes("shippingAddress")
        ? "shipping"
        : "";

    if (scope) {
      const field = addressFieldMap[leaf];
      return field ? `${scope}_${field}` : null;
    }

    return contactFieldMap[leaf] || null;
  }

  // =========================
  // ERROR UI
  // =========================
  const errorIcon = form.dataset.errorIcon || "";

  function showFieldError(input, message) {
    const field = input.closest(".field");
    if (!field) return;

    field.classList.add("field--with-error");
    input.setAttribute("aria-invalid", "true");

    const errorId = `${input.id}-error`;
    input.setAttribute("aria-describedby", errorId);

    const existing = field.querySelector(".contact__field-error");
    if (existing) existing.remove();

    const error = document.createElement("small");
    error.className = "contact__field-error";
    error.id = errorId;

    const visuallyHidden = document.createElement("span");
    visuallyHidden.className = "visually-hidden";
    visuallyHidden.textContent = translations.error;

    const formMessage = document.createElement("span");
    formMessage.className = "form__message";

    const svgWrapper = document.createElement("span");
    svgWrapper.className = "svg-wrapper";
    svgWrapper.setAttribute("aria-hidden", "true");

    if (errorIcon) {
      svgWrapper.innerHTML = errorIcon;
    }

    const textNode = document.createTextNode(message || "");

    formMessage.appendChild(svgWrapper);
    formMessage.appendChild(textNode);

    error.appendChild(visuallyHidden);
    error.appendChild(formMessage);

    field.appendChild(error);
  }

  // The success border is painted from this flag rather than from :valid,
  // which for most fields only means "not empty and no native constraint
  // broken" - and would go green on a phone number of Cyrillic letters, or on
  // a postal code no country has been picked to check it against.
  function setVerified(input, verified) {
    if (verified) input.dataset.verified = "true";
    else delete input.dataset.verified;
  }

  function clearFieldError(input) {
    const field = input.closest(".field");
    if (!field) return;

    field.classList.remove("field--with-error");
    input.removeAttribute("aria-invalid");
    input.removeAttribute("aria-describedby");

    const error = field.querySelector(".contact__field-error");
    if (error) error.remove();
  }

  function clearAllErrors() {
    form
      .querySelectorAll(".field__input, select, textarea")
      .forEach(clearFieldError);
  }

  // =========================
  // LOCATION SELECTORS
  // =========================
  function clearOptions(select, placeholder) {
    if (!select) return;

    while (select.firstChild) {
      select.removeChild(select.firstChild);
    }

    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.textContent = placeholder;
    placeholderOption.selected = true;
    select.appendChild(placeholderOption);

    setVerified(select, false);
  }

  // Zones are [zoneCode, name] pairs, see snippets/b2b-country-options.liquid.
  function getZones(countrySelect) {
    const selected = countrySelect.options[countrySelect.selectedIndex];

    try {
      return JSON.parse(selected?.getAttribute("data-zones") || "[]");
    } catch (error) {
      return [];
    }
  }

  // With no country picked the field stays in place, just empty and disabled,
  // so the address grid does not collapse.
  function syncProvinces(countrySelect, provinceSelect) {
    if (!countrySelect || !provinceSelect) return;

    const zones = getZones(countrySelect);
    const placeholder = zones.length
      ? `${translations.province}*`
      : translations.provinceNoCountry;

    clearOptions(provinceSelect, placeholder);

    if (zones.length === 0) {
      provinceSelect.disabled = true;
      return;
    }

    zones.forEach(([code, name]) => {
      const option = document.createElement("option");
      option.value = code;
      option.textContent = name;
      provinceSelect.appendChild(option);
    });

    provinceSelect.disabled = false;
  }

  // The country code is fully derived from the country dropdown and hidden, so
  // it is never shown or typed into - it exists to carry `countryCode` in the
  // payload, where the API wants the ISO code rather than the country name.
  function syncCountryCode(countrySelect, codeInput) {
    if (!countrySelect || !codeInput) return;

    const selected = countrySelect.options[countrySelect.selectedIndex];
    codeInput.value = selected?.getAttribute("data-code") || "";
  }

  // The format is worth knowing before the field is filled in, not after it
  // is rejected, so the picked country puts its example in the placeholder.
  // The base placeholder ends with the required marker, and the example goes
  // in ahead of it: "ZIP / Postal code (K1A 0B1)*".
  function syncZipHint(zipInput, codeInput) {
    if (!zipInput) return;

    if (zipInput.dataset.placeholderBase === undefined) {
      zipInput.dataset.placeholderBase = zipInput.placeholder;
    }

    const base = zipInput.dataset.placeholderBase;
    const example = zipRules[(codeInput?.value || "").toUpperCase()]?.example;

    if (!example) {
      zipInput.placeholder = base;
      return;
    }

    const marker = base.endsWith("*") ? "*" : "";
    const label = marker ? base.slice(0, -1) : base;
    zipInput.placeholder = `${label} (${example})${marker}`;
  }

  function setupLocationSelectors() {
    const bindCountry = ({
      countrySelect,
      provinceSelect,
      codeInput,
      zipInput,
    }) => {
      if (!countrySelect || !provinceSelect) return;

      const update = () => {
        syncProvinces(countrySelect, provinceSelect);
        syncCountryCode(countrySelect, codeInput);
        syncZipHint(zipInput, codeInput);
      };

      countrySelect.addEventListener("change", update);
      update();
    };

    bindCountry({
      countrySelect: shippingCountrySelect,
      provinceSelect: shippingProvinceSelect,
      codeInput: shippingCountryCodeInput,
      zipInput: shippingZipInput,
    });
    bindCountry({
      countrySelect: billingCountrySelect,
      provinceSelect: billingProvinceSelect,
      codeInput: billingCountryCodeInput,
      zipInput: billingZipInput,
    });
  }

  setupLocationSelectors();

  // =========================
  // CITY AUTOCOMPLETE
  // =========================
  // Free text with suggestions from Photon (OpenStreetMap): free, no API key.
  // The field works as a plain text input if the service is slow or down - the
  // suggestions are an enhancement, never a requirement.
  const PHOTON_URL = "https://photon.komoot.io/api";
  const CITY_MIN_CHARS = 2;
  const CITY_DEBOUNCE_MS = 300;

  // Photon spells zones as OSM does ("Québec"), Shopify as "Quebec", so compare
  // without diacritics or case.
  function normalizeName(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .trim()
      .toLowerCase();
  }

  function availableCountryCodes(countrySelect) {
    if (!countrySelect) return [];

    return [...countrySelect.options]
      .map((option) => option.getAttribute("data-code"))
      .filter(Boolean);
  }

  // Photon ranks worldwide, so a query like "new" is filled with New York and
  // New Delhi and the Canadian matches never make the cut. A bounding box keeps
  // the ranking local. With no country picked yet, cover every country offered.
  function searchArea(countrySelect, countryCode) {
    if (!countrySelect) return "";

    const boxes = [...countrySelect.options]
      .filter(
        (option) =>
          !countryCode || option.getAttribute("data-code") === countryCode,
      )
      .map((option) => option.getAttribute("data-bbox"))
      .filter(Boolean)
      .map((box) => box.split(",").map(Number));

    if (boxes.length === 0) return "";

    return [
      Math.min(...boxes.map((b) => b[0])),
      Math.min(...boxes.map((b) => b[1])),
      Math.max(...boxes.map((b) => b[2])),
      Math.max(...boxes.map((b) => b[3])),
    ].join(",");
  }

  // Picking a city also picks its country, so the form can be filled starting
  // from the city field. Dispatching change repopulates provinces and the
  // country code, which have to exist before the zone can be selected.
  function selectCountryByCode(countrySelect, code) {
    if (!countrySelect || !code) return;

    const current = countrySelect.options[countrySelect.selectedIndex];
    if (current?.getAttribute("data-code") === code) return;

    const match = [...countrySelect.options].find(
      (option) => option.getAttribute("data-code") === code,
    );
    if (!match) return;

    countrySelect.value = match.value;
    countrySelect.dispatchEvent(new Event("change"));
    clearFieldError(countrySelect);
  }

  function selectZoneByName(provinceSelect, stateName) {
    if (!provinceSelect || !stateName) return;

    const wanted = normalizeName(stateName);
    const match = [...provinceSelect.options].find(
      (option) => option.value && normalizeName(option.textContent) === wanted,
    );

    if (match) {
      provinceSelect.value = match.value;
      provinceSelect.dispatchEvent(new Event("change"));
      clearFieldError(provinceSelect);
    }
  }

  function setupCityAutocomplete(cityInput, countrySelect, provinceSelect) {
    if (!cityInput) return;

    const results = document.getElementById(
      cityInput.getAttribute("aria-controls"),
    );
    if (!results) return;

    let timer = null;
    let controller = null;
    let items = [];
    let activeIndex = -1;

    const close = () => {
      results.hidden = true;
      results.replaceChildren();
      cityInput.setAttribute("aria-expanded", "false");
      cityInput.removeAttribute("aria-activedescendant");
      items = [];
      activeIndex = -1;
    };

    const setActive = (index) => {
      const options = [...results.children];
      options.forEach((el, i) => {
        const active = i === index;
        el.classList.toggle("is-active", active);
        el.setAttribute("aria-selected", active ? "true" : "false");
      });

      activeIndex = index;

      if (options[index]) {
        cityInput.setAttribute("aria-activedescendant", options[index].id);
        options[index].scrollIntoView({ block: "nearest" });
      } else {
        cityInput.removeAttribute("aria-activedescendant");
      }
    };

    const choose = (index) => {
      const item = items[index];
      if (!item) return;

      cityInput.value = item.name;
      clearFieldError(cityInput);
      selectCountryByCode(countrySelect, item.countryCode);
      selectZoneByName(provinceSelect, item.state);
      close();
    };

    const render = () => {
      results.replaceChildren();

      items.forEach((item, i) => {
        const li = document.createElement("li");
        li.id = `${results.id}-option-${i}`;
        li.className = "b2b-registration__autocomplete-option";
        li.setAttribute("role", "option");
        li.setAttribute("aria-selected", "false");

        const name = document.createElement("span");
        name.className = "b2b-registration__autocomplete-name";
        name.textContent = item.name;

        const context = document.createElement("span");
        context.className = "b2b-registration__autocomplete-context";
        context.textContent = item.state || "";

        li.appendChild(name);
        if (item.state) li.appendChild(context);

        li.addEventListener("mousedown", (event) => {
          // mousedown, not click: blur would close the list first.
          event.preventDefault();
          choose(i);
        });

        results.appendChild(li);
      });

      results.hidden = items.length === 0;
      cityInput.setAttribute("aria-expanded", items.length ? "true" : "false");
    };

    const search = async (query) => {
      const selected = countrySelect?.options[countrySelect.selectedIndex];
      const countryCode = selected?.getAttribute("data-code") || "";

      controller?.abort();
      controller = new AbortController();

      // Photon has no country parameter, so ask for far more than we show,
      // bias the ranking to the countries offered, and narrow the rest below.
      const area = searchArea(countrySelect, countryCode);
      const url =
        `${PHOTON_URL}?q=${encodeURIComponent(query)}&layer=city&limit=50` +
        (area ? `&bbox=${area}` : "");

      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error("Photon request failed");

        const data = await response.json();

        // Photon has no country filter, so narrow the results here. With no
        // country picked yet, allow any the form offers - picking such a city
        // selects its country too. Suggesting a city the form cannot represent
        // would be a dead end.
        const allowed = countryCode
          ? [countryCode]
          : availableCountryCodes(countrySelect);

        const seen = new Set();
        items = (data.features || [])
          .map((feature) => feature.properties || {})
          .filter((props) => {
            if (!props.name) return false;
            if (!allowed.includes(props.countrycode)) return false;

            const key = `${props.name}|${props.state || ""}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          })
          .slice(0, 6)
          .map((props) => ({
            name: props.name,
            state: props.state || "",
            countryCode: props.countrycode || "",
          }));

        render();
      } catch (error) {
        // Aborted or offline: leave the field as plain text input.
        if (error.name !== "AbortError") close();
      }
    };

    cityInput.addEventListener("input", () => {
      const query = cityInput.value.trim();
      window.clearTimeout(timer);

      if (query.length < CITY_MIN_CHARS) {
        controller?.abort();
        close();
        return;
      }

      timer = window.setTimeout(() => search(query), CITY_DEBOUNCE_MS);
    });

    cityInput.addEventListener("keydown", (event) => {
      if (results.hidden || items.length === 0) return;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        setActive((activeIndex + 1) % items.length);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        setActive((activeIndex - 1 + items.length) % items.length);
      } else if (event.key === "Enter" && activeIndex >= 0) {
        event.preventDefault();
        choose(activeIndex);
      } else if (event.key === "Escape") {
        close();
      }
    });

    cityInput.addEventListener("blur", close);

    // A different country invalidates whatever was suggested for the old one.
    countrySelect?.addEventListener("change", close);
  }

  setupCityAutocomplete(
    document.getElementById("CompanyRegistration-city"),
    shippingCountrySelect,
    shippingProvinceSelect,
  );
  setupCityAutocomplete(
    document.getElementById("CompanyRegistration-billing-city"),
    billingCountrySelect,
    billingProvinceSelect,
  );

  function refreshLocationSelectors() {
    shippingCountrySelect?.dispatchEvent(new Event("change"));
    billingCountrySelect?.dispatchEvent(new Event("change"));
  }

  // =========================
  // BILLING LOGIC (FIXED)
  // =========================
  const billingToggle = form.querySelector("#CompanyRegistration-billing-same");

  const billingAllFields = form.querySelectorAll("[name^='billing_']");

  // The shipping set, mirrored: everything the B2B API needs for a usable
  // address, minus the country code, zone code and formatted area, which the
  // form derives from the dropdowns rather than asking for.
  const billingRequiredFields = new Set([
    "billing_address",
    "billing_country",
    "billing_city",
    "billing_province",
    "billing_zip",
  ]);

  function isBillingRequired() {
    return billingToggle ? !billingToggle.checked : true;
  }

  function updateBillingRequiredState() {
    const required = isBillingRequired();

    billingAllFields.forEach((el) => {
      const name = el.getAttribute("name");

      const isCoreRequired = billingRequiredFields.has(name);

      if (required && isCoreRequired) {
        el.setAttribute("required", "true");
      } else {
        el.removeAttribute("required");
        clearFieldError(el);
      }
    });
  }

  updateBillingRequiredState();

  billingToggle?.addEventListener("change", updateBillingRequiredState);

  // =========================
  // VALIDATION
  // =========================
  function validateForm() {
    let valid = true;

    const billingRequired = isBillingRequired();

    const inputs = form.querySelectorAll("input, select, textarea");

    inputs.forEach((input) => {
      if (!validateInput(input, billingRequired)) valid = false;
    });

    return valid;
  }

  function validateInput(input, billingRequired = isBillingRequired()) {
    const name = input.getAttribute("name");
    const isBillingField = name?.startsWith("billing_");

    // Neither of these has a value to check or a border to paint: a hidden
    // input carries a derived value - the country code - and a checkbox is
    // either ticked or not, while `value` reports its attribute either way.
    if (input.type === "hidden" || input.type === "checkbox") return true;

    // A disabled control submits nothing and cannot be corrected where it
    // stands: the province select is disabled until a country is chosen, and
    // the missing country is what the customer actually has to fix.
    if (input.disabled) {
      input.setCustomValidity("");
      clearFieldError(input);
      setVerified(input, false);
      return true;
    }
    const rawValue = typeof input.value === "string" ? input.value : "";
    const value = rawValue.trim();

    if (isBillingField && !billingRequired) {
      input.setCustomValidity("");
      clearFieldError(input);
      return true;
    }

    if (isBillingField) {
      const isCore = billingRequiredFields.has(name);
      if (!isCore && !value) {
        input.setCustomValidity("");
        clearFieldError(input);
        return true;
      }
    }

    input.setCustomValidity("");

    const isCountrySelect =
      name === "shipping_country" || name === "billing_country";
    const isProvinceSelect =
      name === "shipping_province" || name === "billing_province";

    if (input.hasAttribute("required") && !value) {
      if (isCountrySelect) {
        input.setCustomValidity(translations.selectCountry);
      } else if (isProvinceSelect) {
        input.setCustomValidity(translations.selectProvince);
      } else {
        input.setCustomValidity(translations.required);
      }
    }

    if (input.type === "tel" && value) {
      const hasLetters = /[A-Za-z]/.test(value);
      const digitsCount = (value.match(/\d/g) || []).length;
      const hasEnoughDigits = digitsCount >= 6;
      if (hasLetters || !phonePattern.test(value) || !hasEnoughDigits) {
        input.setCustomValidity(translations.phone);
      }
    }

    const isAddressLine =
      name === "shipping_address" || name === "billing_address";
    if (isAddressLine && value) {
      const hasAlphaNum = /[\p{L}\p{N}]/u.test(value);
      const isValidAddress =
        value.length >= 3 && hasAlphaNum && addressPattern.test(value);
      if (!isValidAddress) input.setCustomValidity(translations.address);
    }

    const isCountryCode =
      name === "shipping_country_code" || name === "billing_country_code";
    if (isCountryCode && value && !countryCodePattern.test(value)) {
      input.setCustomValidity(translations.countryCode);
    }

    const isZip = name === "shipping_zip" || name === "billing_zip";
    if (isZip && value) {
      const codeInput =
        name === "shipping_zip"
          ? shippingCountryCodeInput
          : billingCountryCodeInput;
      const rule = zipRules[(codeInput?.value || "").toUpperCase()];

      if (rule) {
        if (!rule.pattern.test(value)) input.setCustomValidity(rule.message);
      } else if (!zipShapePattern.test(value)) {
        input.setCustomValidity(translations.zip);
      }
    }

    if (input.validity.valid) {
      clearFieldError(input);
      setVerified(input, value !== "");
      return true;
    }

    let message = translations.required;
    if (input.validity.customError) {
      message = input.validationMessage || translations.required;
    } else if (input.validity.valueMissing) {
      message = translations.required || "This field is required";
    } else if (input.validity.typeMismatch) {
      message = translations.email || "Enter a valid value";
    } else if (input.validity.tooShort) {
      message = translations.tooShort || "Too short";
    } else if (input.validity.patternMismatch) {
      message = translations.pattern || "Invalid format";
    }

    showFieldError(input, message);
    setVerified(input, false);
    return false;
  }

  // =========================
  // SUBMIT BUTTON
  // =========================
  // The theme's own busy state: `loading` on the button blanks its label and
  // centres the spinner, which ships hidden until there is something to wait
  // for. Disabled with it, so the request cannot be fired twice.
  function setSubmitting(busy) {
    if (!submitBtn) return;

    submitBtn.disabled = busy;
    submitBtn.classList.toggle("loading", busy);
    submitBtn.setAttribute("aria-busy", busy ? "true" : "false");
    submitSpinner?.classList.toggle("hidden", !busy);
  }

  // =========================
  // STATUS
  // =========================
  function setStatus(message, type) {
    if (!statusEl) return;

    statusEl.textContent = message;
    statusEl.dataset.status = type;
    statusEl.setAttribute("aria-live", "polite");

    if (type === "error") statusEl.setAttribute("role", "alert");
    else statusEl.removeAttribute("role");
  }

  // The banner is only rewritten by the next submit, so a form that has since
  // been filled in correctly went on reading as wrong. It goes as soon as the
  // last field error does. Only this message: one from the app is a report on
  // a request, not on the fields, and a keystroke should not wipe it.
  function clearStatusWhenClean() {
    if (!statusEl || statusEl.textContent !== translations.fixErrors) return;
    if (form.querySelector(".field--with-error")) return;

    setStatus("", "");
  }

  // =========================
  // MODAL
  // =========================
  function openModal(message) {
    if (!modal) return;

    if (modalMessage) modalMessage.textContent = message;

    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    if (!modal) return;

    modal.hidden = true;
    document.body.style.overflow = "";
  }

  modal?.querySelectorAll("[data-modal-close]").forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  // =========================
  // INPUT EVENTS
  // =========================
  form.querySelectorAll("input, select, textarea").forEach((input) => {
    input.addEventListener("input", () => {
      input.setCustomValidity("");
      // Typing withdraws the verdict until the next blur re-checks the field.
      setVerified(input, false);
      if (input.checkValidity()) clearFieldError(input);
      clearStatusWhenClean();
    });
    input.addEventListener("change", () => {
      input.setCustomValidity("");
      // Same withdrawal as on input: a select fires change on paths that never
      // fire input - the city autocomplete picks its country and province in
      // code, and the reset after a successful submit resyncs them - so the
      // verdict has to go here too, or it outlives the value it was given for.
      setVerified(input, false);
      if (input.checkValidity()) clearFieldError(input);
      clearStatusWhenClean();
    });
    input.addEventListener("blur", () => {
      const filled = typeof input.value === "string" && input.value.trim();

      // Whatever was typed is checked as soon as the field is left. An empty
      // field is let past on the way down - not filled in yet is not a mistake
      // - until it has been visited once, or the submit asks for everything.
      if (filled || input.dataset.touched) validateInput(input);
      input.dataset.touched = "true";
      clearStatusWhenClean();
    });
  });

  // =========================
  // SELECT KEYBOARD
  // =========================
  // Enter on a focused select is implicit form submission, so reaching for a
  // dropdown mid-form validated the whole form instead of opening the list.
  // Open it where the browser can - showPicker() is not baseline yet - and
  // otherwise just stay put; Space and the arrow keys open it natively.
  form.querySelectorAll("select").forEach((select) => {
    select.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return;

      event.preventDefault();

      try {
        select.showPicker();
      } catch (error) {
        // Unsupported, or the browser declined: leave the list closed.
      }
    });
  });

  // =========================
  // SUBMIT
  // =========================
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    clearAllErrors();

    const isValid = validateForm();

    if (!isValid) {
      setStatus(translations.fixErrors, "error");

      const firstError = form.querySelector(
        ".field--with-error input, .field--with-error select",
      );
      if (firstError) firstError.focus();
      return;
    }

    setStatus("", "");
    setSubmitting(true);

    try {
      const payload = buildPayload(new FormData(form));

      const response = await fetch("/apps/acegifts/b2b-customer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        if (Array.isArray(data.errors) && data.errors.length) {
          const unplaced = [];

          data.errors.forEach((err) => {
            const inputName = resolveBackendField(err.field);
            const input =
              inputName && form.querySelector(`[name="${inputName}"]`);

            if (input) showFieldError(input, err.message);
            else if (err.message) unplaced.push(err.message);
          });

          // An error we cannot pin to a field would otherwise leave the
          // customer reading about highlighted fields with none highlighted,
          // and the reason the app gave thrown away.
          throw new Error(
            unplaced.length ? unplaced.join(" ") : translations.fixErrors,
          );
        }

        throw new Error(data.error || translations.genericError);
      }

      form.reset();
      form
        .querySelectorAll(".field__input, select, textarea")
        .forEach((field) => setVerified(field, false));
      refreshLocationSelectors();
      updateBillingRequiredState();
      setStatus("", "");
      openModal(translations.success);
    } catch (error) {
      setStatus(error.message, "error");
    } finally {
      setSubmitting(false);
    }
  });

  // =========================
  // PAYLOAD
  // =========================
  function buildPayload(formData) {
    const billingSameAsShipping =
      formData.get("billing_same_as_shipping") === "yes";

    // ISO country codes are canonically uppercase, and the field is free text.
    const countryCode = (name) =>
      (formData.get(name) || "").trim().toUpperCase();

    const payload = {
      companyName: formData.get("company_name"),
      taxIdentifier: formData.get("tax_identifier"),
      contactFirstName: formData.get("customer[first_name]"),
      contactLastName: formData.get("customer[last_name]"),
      contactEmail: formData.get("customer[email]"),
      contactPhone: formData.get("phone"),
      locationName: "Primary Location",
      locationPhone: formData.get("phone"),
      shippingAddress1: formData.get("shipping_address"),
      shippingAddress2: formData.get("shipping_address2"),
      shippingCity: formData.get("shipping_city"),
      // Disabled selects are not submitted, so a country without provinces
      // would drop the key entirely instead of sending an empty value.
      shippingZoneCode: formData.get("shipping_province") || "",
      shippingZip: formData.get("shipping_zip"),
      shippingCountryCode: countryCode("shipping_country_code"),
      billingSameAsShipping,
      isDropshipping: formData.get("plan_dropshipping") === "yes",
    };

    if (!billingSameAsShipping) {
      payload.billingAddress1 = formData.get("billing_address");
      payload.billingAddress2 = formData.get("billing_address2");
      payload.billingCity = formData.get("billing_city");
      payload.billingZoneCode = formData.get("billing_province") || "";
      payload.billingZip = formData.get("billing_zip");
      payload.billingCountryCode = countryCode("billing_country_code");
    }

    return payload;
  }
});
